/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataCollections } from '../models/data-collections';
import { DataCollectionsPartialExcludingIdUpdateInfoCreationInfoIsImplicitRelatedToModule } from '../models/data-collections-partial-excluding-id-update-info-creation-info-is-implicit-related-to-module';
import { DataCollectionsPermissionsDtoWithRelations } from '../models/data-collections-permissions-dto-with-relations';
import { DataCollectionsShareModel } from '../models/data-collections-share-model';
import { DataCollectionsWithRelations } from '../models/data-collections-with-relations';
import { DataEntriesResponseV3 } from '../models/data-entries-response-v-3';
import { DataEntryExcludingSearchIndex } from '../models/data-entry-excluding-search-index';
import { DuplicatedDataCollections } from '../models/duplicated-data-collections';
import { NewDataCollections } from '../models/new-data-collections';
import { NewDataCollectionsV2 } from '../models/new-data-collections-v-2';
import { PatchDataCollectionItemsDto } from '../models/patch-data-collection-items-dto';
import { PatchDataCollectionReturnDetailsDto } from '../models/patch-data-collection-return-details-dto';
import { ReplaceDataCollections } from '../models/replace-data-collections';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class DataCollectionsControllerService extends DataBaseService {

  /**
   * Path part for operation dataCollectionsControllerCountAll
   */
  static readonly DataCollectionsControllerCountAllPath = '/v1/collections/count';

  /**
   * Get collections count
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  countAll$Response(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerCountAllPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get collections count
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `countAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countAll(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.countAll$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindMyCollections
   */
  static readonly DataCollectionsControllerFindMyCollectionsPath = '/v1/collections/my';

  /**
   * List all user collections in a specific view or in all views
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findMyCollections()` instead.
   *
   * This method doesn't expect any request body.
   */
  findMyCollections$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataCollectionsWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindMyCollectionsPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataCollectionsWithRelations>>;
      })
    );
  }
  /**
   * List all user collections in a specific view or in all views
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findMyCollections$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findMyCollections(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataCollectionsWithRelations>> {

    return this.findMyCollections$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataCollectionsWithRelations>>) => r.body as Array<DataCollectionsWithRelations>)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindSharedCollections
   */
  static readonly DataCollectionsControllerFindSharedCollectionsPath = '/v1/collections/shared';

  /**
   * List all user shared collections in a specific view or in all views
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findSharedCollections()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSharedCollections$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataCollectionsWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindSharedCollectionsPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataCollectionsWithRelations>>;
      })
    );
  }
  /**
   * List all user shared collections in a specific view or in all views
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findSharedCollections$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSharedCollections(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataCollectionsWithRelations>> {

    return this.findSharedCollections$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataCollectionsWithRelations>>) => r.body as Array<DataCollectionsWithRelations>)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindByIdWithoutEntity
   */
  static readonly DataCollectionsControllerFindByIdWithoutEntityPath = '/v1/collections/{id}';

  /**
   * Get all collections
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByIdWithoutEntity()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdWithoutEntity$Response(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataCollectionsWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindByIdWithoutEntityPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataCollectionsWithRelations>>;
      })
    );
  }
  /**
   * Get all collections
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByIdWithoutEntity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdWithoutEntity(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataCollectionsWithRelations>> {

    return this.findByIdWithoutEntity$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataCollectionsWithRelations>>) => r.body as Array<DataCollectionsWithRelations>)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindAll
   */
  static readonly DataCollectionsControllerFindAllPath = '/v1/collections';

  /**
   * Get all collections
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataCollectionsWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindAllPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataCollectionsWithRelations>>;
      })
    );
  }
  /**
   * Get all collections
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataCollectionsWithRelations>> {

    return this.findAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataCollectionsWithRelations>>) => r.body as Array<DataCollectionsWithRelations>)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerCount
   */
  static readonly DataCollectionsControllerCountPath = '/v1/entities/{entity}/collections/count';

  /**
   * Count specific entity collections
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params: {
    entity: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count specific entity collections
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params: {
    entity: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerDuplicate
   */
  static readonly DataCollectionsControllerDuplicatePath = '/v1/entities/{entity}/collections/{id}/duplicate';

  /**
   * Duplicate data collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `duplicate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  duplicate$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DuplicatedDataCollections
  }): Observable<StrictHttpResponse<DataCollections>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerDuplicatePath, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataCollections>;
      })
    );
  }
  /**
   * Duplicate data collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `duplicate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  duplicate(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DuplicatedDataCollections
  }): Observable<DataCollections> {

    return this.duplicate$Response(params).pipe(
      map((r: StrictHttpResponse<DataCollections>) => r.body as DataCollections)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindEntriesCount
   */
  static readonly DataCollectionsControllerFindEntriesCountPath = '/v1/entities/{entity}/collections/{id}/entries/count';

  /**
   * Get specific entity collection count
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntriesCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesCount$Response(params: {
    entity: string;
    id: string;
    where?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindEntriesCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get specific entity collection count
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntriesCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesCount(params: {
    entity: string;
    id: string;
    where?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.findEntriesCount$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindEntries
   */
  static readonly DataCollectionsControllerFindEntriesPath = '/v1/entities/{entity}/collections/{id}/entries';

  /**
   * Get specific entity collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntries$Response(params: {
    entity: string;
    id: string;
    filter?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindEntriesPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>;
      })
    );
  }
  /**
   * Get specific entity collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntries(params: {
    entity: string;
    id: string;
    filter?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntryExcludingSearchIndex>> {

    return this.findEntries$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>) => r.body as Array<DataEntryExcludingSearchIndex>)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerUpdateCollectionItems
   */
  static readonly DataCollectionsControllerUpdateCollectionItemsPath = '/v1/entities/{entity}/collections/{id}/entries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCollectionItems()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCollectionItems$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: Array<any>
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerUpdateCollectionItemsPath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateCollectionItems$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCollectionItems(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: Array<any>
  }): Observable<any> {

    return this.updateCollectionItems$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerShare
   */
  static readonly DataCollectionsControllerSharePath = '/v1/entities/{entity}/collections/{id}/share';

  /**
   * Share collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `share()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  share$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataCollectionsShareModel
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerSharePath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Share collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `share$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  share(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataCollectionsShareModel
  }): Observable<any> {

    return this.share$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindById
   */
  static readonly DataCollectionsControllerFindByIdPath = '/v1/entities/{entity}/collections/{id}';

  /**
   * Get specific entity collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataCollectionsPermissionsDtoWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindByIdPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataCollectionsPermissionsDtoWithRelations>;
      })
    );
  }
  /**
   * Get specific entity collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataCollectionsPermissionsDtoWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataCollectionsPermissionsDtoWithRelations>) => r.body as DataCollectionsPermissionsDtoWithRelations)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerReplaceById
   */
  static readonly DataCollectionsControllerReplaceByIdPath = '/v1/entities/{entity}/collections/{id}';

  /**
   * Update specific entity collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ReplaceDataCollections
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerReplaceByIdPath, 'put');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update specific entity collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ReplaceDataCollections
  }): Observable<any> {

    return this.replaceById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerDeleteById
   */
  static readonly DataCollectionsControllerDeleteByIdPath = '/v1/entities/{entity}/collections/{id}';

  /**
   * Delete specific entity collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete specific entity collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerUpdateById
   */
  static readonly DataCollectionsControllerUpdateByIdPath = '/v1/entities/{entity}/collections/{id}';

  /**
   * Update specific entity collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataCollectionsPartialExcludingIdUpdateInfoCreationInfoIsImplicitRelatedToModule
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update specific entity collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataCollectionsPartialExcludingIdUpdateInfoCreationInfoIsImplicitRelatedToModule
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFind
   */
  static readonly DataCollectionsControllerFindPath = '/v1/entities/{entity}/collections';

  /**
   * Get all entity collections
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataCollectionsWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataCollectionsWithRelations>>;
      })
    );
  }
  /**
   * Get all entity collections
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataCollectionsWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataCollectionsWithRelations>>) => r.body as Array<DataCollectionsWithRelations>)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerCreate
   */
  static readonly DataCollectionsControllerCreatePath = '/v1/entities/{entity}/collections';

  /**
   * Create new data collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataCollections
  }): Observable<StrictHttpResponse<DataCollections>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerCreatePath, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataCollections>;
      })
    );
  }
  /**
   * Create new data collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataCollections
  }): Observable<DataCollections> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataCollections>) => r.body as DataCollections)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindEntriesCountV2
   */
  static readonly DataCollectionsControllerFindEntriesCountV2Path = '/v2/entities/{entity}/collections/{id}/entries/count';

  /**
   * Get specific entity collection count
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntriesCountV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesCountV2$Response(params: {
    entity: string;
    id: string;
    where?: any;
    search?: string;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindEntriesCountV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.query('search', params.search, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get specific entity collection count
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntriesCountV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesCountV2(params: {
    entity: string;
    id: string;
    where?: any;
    search?: string;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.findEntriesCountV2$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerFindEntriesV2
   */
  static readonly DataCollectionsControllerFindEntriesV2Path = '/v2/entities/{entity}/collections/{id}/entries';

  /**
   * Get specific entity collection with applied tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntriesV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesV2$Response(params: {
    entity: string;
    id: string;
    filter?: any;
    search?: string;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    appliedTagsFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataEntriesResponseV3>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerFindEntriesV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.query('search', params.search, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.query('appliedTagsFilters', params.appliedTagsFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntriesResponseV3>;
      })
    );
  }
  /**
   * Get specific entity collection with applied tags
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntriesV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesV2(params: {
    entity: string;
    id: string;
    filter?: any;
    search?: string;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    appliedTagsFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataEntriesResponseV3> {

    return this.findEntriesV2$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntriesResponseV3>) => r.body as DataEntriesResponseV3)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerUpdateCollectionItemsV2
   */
  static readonly DataCollectionsControllerUpdateCollectionItemsV2Path = '/v2/entities/{entity}/collections/{id}/entries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCollectionItemsV2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCollectionItemsV2$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: PatchDataCollectionItemsDto
  }): Observable<StrictHttpResponse<PatchDataCollectionReturnDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerUpdateCollectionItemsV2Path, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PatchDataCollectionReturnDetailsDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateCollectionItemsV2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCollectionItemsV2(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: PatchDataCollectionItemsDto
  }): Observable<PatchDataCollectionReturnDetailsDto> {

    return this.updateCollectionItemsV2$Response(params).pipe(
      map((r: StrictHttpResponse<PatchDataCollectionReturnDetailsDto>) => r.body as PatchDataCollectionReturnDetailsDto)
    );
  }

  /**
   * Path part for operation dataCollectionsControllerCreateV2
   */
  static readonly DataCollectionsControllerCreateV2Path = '/v2/entities/{entity}/collections';

  /**
   * Create new data collection
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createV2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createV2$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataCollectionsV2
  }): Observable<StrictHttpResponse<DataCollections>> {

    const rb = new RequestBuilder(this.rootUrl, DataCollectionsControllerService.DataCollectionsControllerCreateV2Path, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataCollections>;
      })
    );
  }
  /**
   * Create new data collection
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createV2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createV2(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataCollectionsV2
  }): Observable<DataCollections> {

    return this.createV2$Response(params).pipe(
      map((r: StrictHttpResponse<DataCollections>) => r.body as DataCollections)
    );
  }

}
